import { OsmQueueStatsDto, SystemHealthDto } from '@ivy-monorepo/shared'
import { apiClient } from './api-client'

class SystemHealthService {
  async getSystemHealth(refresh = false): Promise<SystemHealthDto> {
    const response = await apiClient.get('/admin/system-health', {
      params: refresh ? { refresh: true } : undefined,
    })
    return response.data
  }

  async getOsmQueueStats(): Promise<OsmQueueStatsDto> {
    const response = await apiClient.get('/admin/osm-queue-stats')
    return response.data
  }
}

export const systemHealthService = new SystemHealthService()
